import { render, staticRenderFns } from "./Preamble.vue?vue&type=template&id=b2ca6d30&scoped=true&"
import script from "./Preamble.vue?vue&type=script&lang=js&"
export * from "./Preamble.vue?vue&type=script&lang=js&"
import style0 from "./Preamble.vue?vue&type=style&index=0&id=b2ca6d30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2ca6d30",
  null
  
)

export default component.exports